import BaseAPI from '@/apis/base/baseApi';

export default class DVCApi extends BaseAPI {
  apiName = 'DVC';
}
